<vault-organization-user-notifications></vault-organization-user-notifications>
<app-vault-banners [organizations]="organizations()"></app-vault-banners>

<app-header [title]="title()">
  @if (showBreadcrumbs()) {
    <vault-breadcrumbs slot="breadcrumbs" [scope]="vaultScope()"></vault-breadcrumbs>
  } @else if (scopedFolderId(); as folderId) {
    <vault-my-folder-breadcrumbs slot="breadcrumbs" [folderId]="folderId" />
  } @else if (headerTile(); as tile) {
    <bit-icon-tile
      slot="title-prefix"
      [icon]="tile.icon"
      [variant]="tile.variant ?? 'primary'"
      [color]="tile.color"
      [emphasis]="tile.emphasis ?? 'subtle'"
      size="sm"
      aria-hidden="true"
    />
  }

  @if (scopedFolderId(); as folderId) {
    <vault-my-folder-menu slot="title-suffix" [folderId]="folderId" />
  }
  @if (currentCollection(); as collection) {
    <vault-collection-options-menu
      slot="title-suffix"
      [collection]="collection"
      [organization]="currentOrganization()"
      [showPin]="true"
      triggerIcon="bwi-angle-down"
      idPrefix="vault-next"
    />
  }
</app-header>

@if (showSubscriptionEndedMessaging()) {
  <bit-callout type="subtle" [title]="'premiumSubscriptionEnded' | i18n">
    <div>{{ "premiumSubscriptionEndedDesc" | i18n }}</div>
    <a bitLink [routerLink]="['/settings/subscription/premium']">
      {{ "restartPremium" | i18n }}
    </a>
  </bit-callout>
}

<app-vault-onboarding [ciphers]="activeCiphers()"></app-vault-onboarding>

<vault-card-grid
  [collections]="scopedCollections()"
  [folders]="folders()"
  [scope]="vaultScope()"
></vault-card-grid>

<!-- Remounted per scope: the table reads its filters from the URL once, at mount. -->
<vault-items-table
  *vaultRemountOn="filterScopeKey()"
  [ciphers]="ciphers()"
  [loading]="loading()"
  [rowActions]="rowActions()"
  [folders]="folders()"
  [collections]="scopedCollections()"
  [organizations]="scopedOrganizations()"
  [scopedOrganizationId]="scopedOrganizationId()"
  [defaultCollectionId]="defaultCollectionId()"
  [orgRequiresDataOwnership]="orgRequiresDataOwnership()"
  [myVaultItemCount]="myVaultItemCount()"
  [itemAction]="itemAction"
  [copyPresentation]="copyPresentation()"
  [scope]="vaultScope()"
  [organizationName]="emptyVaultOrganizationName()"
  [hasMultipleVaults]="hasMultipleVaults()"
  [sharedFolderName]="emptySharedFolderName()"
  [folderName]="emptyFolderName()"
>
  @if (showItemCreation()) {
    <vault-new-cipher-menu
      slot="empty-add-item"
      [coachmarkEnabled]="false"
      [canCreateCipher]="true"
      [canCreateSshKey]="true"
      [canCreateFolder]="false"
      [canCreateCollection]="false"
      (cipherAdded)="addCipher($event)"
      (onAddItemDialog)="openAddItemDialog('empty')"
      id="vault-next_empty-new-cipher-menu"
    />
  }

  <div slot="toolbar" class="tw-flex tw-items-center tw-gap-3">
    @if (showItemCreation()) {
      <button
        id="vault-next_button_import"
        type="button"
        bitButton
        startIcon="bwi-download"
        buttonType="secondary"
        [bitPopoverAnchorFor]="importCoachmark.popover()"
        [popoverOpen]="importCoachmarkOpen()"
        [position]="coachmarkService.getStepPosition('importData')"
        [closeOnBackdropClick]="false"
        [spotlight]="true"
        (click)="openImport()"
      >
        {{ "importNoun" | i18n }}
      </button>
      <vault-coachmark #importCoachmark stepId="importData" />
      <vault-new-cipher-menu
        [canCreateCipher]="true"
        [canCreateSshKey]="true"
        [canCreateFolder]="true"
        [canCreateCollection]="canCreateCollections()"
        (cipherAdded)="addCipher($event)"
        (onAddItemDialog)="openAddItemDialog('toolbar')"
        (folderAdded)="addFolder()"
        (collectionAdded)="addCollection()"
      />
    }
  </div>
</vault-items-table>

<bit-vault-batch-action />
